import Glide from "@glidejs/glide";
let glide = null;

function initPartnerSlider(id) {
	glide = new Glide("#" + id, {
		type: "carousel",
		bound: true,
		startAt: 0,
		gap: 15,
		perView: 8,
		perSwipe: "|",
		breakpoints: {
			900: {
				perView: 3,
				gap: 0,
			},
		},
		autoplay: 1,
		animationDuration: 3000,
		animationTimingFunc: "linear",
	});

	glide.mount();
}

export function moveGlide(whichWay) {
	glide.go(whichWay);
}

window.initPartnerSlider = initPartnerSlider;
